// icon:bxl-netlify | Boxicons https://boxicons.com/ | Atisa
import * as React from "react";
import Icon from "../../images/art/icons/Universe.png";

function IconBxlNetlify(props) {
	return (
		<img src={Icon} style={{ height: '1em', width: '1em', ...props }} alt={"Universe"} />
	)
}

export default IconBxlNetlify;
